import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import { useTheme } from "./context/ThemeContext";

export default function MenuLateral() {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const { isDarkMode, toggleTheme } = useTheme();
  const location = useLocation();
  const [selected, setSelected] = useState("dashboard");
  const [showPopup, setShowPopup] = useState(false);

  const menuItems = [
    { id: "rastreio", icon: "/icons/mapa.svg", label: "Rastreio", path: "/rastreio" },
    { id: "criar-rota", icon: "/icons/mapa+.svg", label: "Criar Rota", path: "/criar-rota" },
    { id: "visualizar-rotas", icon: "/icons/rout.svg", label: "Visualizar Rotas", path: "/visualizar-rotas" },
    { id: "sair",      icon: "/icons/exit.svg", label: "Sair",      path: "/" },
  ];

  useEffect(() => {
    // Atualiza o estado "selected" com base na URL atual
    const currentPath = location.pathname;
    const currentItem = menuItems.find((item) => item.path === currentPath);
    if (currentItem) {
      setSelected(currentItem.id);
    }
  }, [location.pathname]);

  const handleNavigation = (id, path) => {
    if (id === "sair") {
      setShowPopup(true);
    } else {
      setSelected(id);
      // Forçar o recarregamento da página
      window.location.href = path;
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleConfirmExit = async () => {
    await logout();
    navigate("/");
  };

  const normalItems = menuItems.filter(item => item.id !== "sair");
  const exitItem     = menuItems.find(item => item.id === "sair");

  return (
    <div className="m-4 w-[80px] h-[calc(100vh-2rem)] bg-salBlue dark:bg-dark-surface shadow-lg rounded-2xl flex flex-col items-center py-4">
      {/* logo */}
      <img
        src="/icons/salexpress_logo_red.png"
        alt="Logo SalExpress"
        className="h-6 transition-transform duration-300 mt-2 mb-4"
      />

      {/* Theme toggle button */}
      <div className="mb-4">
        <div
          onClick={toggleTheme}
          className="relative h-12 w-12 flex items-center justify-center rounded-lg cursor-pointer transition-all duration-300 group hover:bg-white-whiter/10 dark:hover:bg-dark-card/50"
        >
          {isDarkMode ? (
            <svg
              className="w-8 h-8 text-yellow-400 transition-transform duration-300 group-hover:scale-110"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                clipRule="evenodd"
              />
            </svg>
          ) : (
            <svg
              className="w-8 h-8 text-gray-600 transition-transform duration-300 group-hover:scale-110"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
            </svg>
          )}
          <span className="absolute left-full ml-2 whitespace-nowrap px-2 py-1 rounded-md bg-gray-800 text-white-whiter z-10 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
            {isDarkMode ? 'Modo Claro' : 'Modo Escuro'}
          </span>
        </div>
      </div>

      {/* ícones principais centralizados */}
      <div className="flex flex-col items-center justify-center flex-1 gap-6">
        {normalItems.map((item) => (
          <div
            key={item.id}
            onClick={() => handleNavigation(item.id, item.path)}
            className={`relative h-12 w-12 flex items-center justify-center rounded-lg cursor-pointer transition-all duration-300 group ${
              selected === item.id 
                ? "bg-white dark:bg-dark-card" 
                : "hover:bg-white-whiter/10 dark:hover:bg-dark-card/50"
            }`}
          >
            <img
              src={item.icon}
              alt={item.label}
              className={`w-8 h-8 transition-transform duration-300 ${
                selected === item.id
                  ? "scale-125 opacity-100"
                  : "group-hover:scale-110 group-hover:opacity-80 opacity-60"
              }`}
            />
            <span className="absolute left-full ml-2 whitespace-nowrap px-2 py-1 rounded-md bg-gray-800 dark:bg-dark-surface text-white-whiter dark:text-dark-text z-10 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
              {item.label}
            </span>
          </div>
        ))}
      </div>

      {/* ícone de sair na base */}
      <div className="mb-4">
        <div
          onClick={() => handleNavigation(exitItem.id, exitItem.path)}
          className={`relative h-12 w-12 flex items-center justify-center rounded-lg cursor-pointer transition-all duration-300 group ${
            selected === exitItem.id 
              ? "bg-white dark:bg-dark-card" 
              : "hover:bg-white-whiter/10 dark:hover:bg-dark-card/50"
          }`}
        >
          <img
            src={exitItem.icon}
            alt={exitItem.label}
            className={`w-8 h-8 transition-transform duration-300 ${
              selected === exitItem.id
                ? "scale-125 opacity-100"
                : "group-hover:scale-110 group-hover:opacity-80 opacity-60"
            }`}
          />
          <span className="absolute left-full ml-2 whitespace-nowrap px-2 py-1 rounded-md bg-gray-800 dark:bg-dark-surface text-white-whiter dark:text-dark-text z-10 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
            {exitItem.label}
          </span>
        </div>
      </div>

      {/* confirmação de logout */}
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center z-30">
          <div className="bg-white-whiter dark:bg-dark-surface p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-2xl font-bold text-text dark:text-dark-text">Confirmação</h2>
            <p className="my-4 text-text dark:text-dark-textSecondary">Você realmente deseja sair?</p>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleConfirmExit}
                className="bg-gray-800 dark:bg-dark-card text-white-whiter dark:text-dark-text font-bold text-xl py-2 px-8 rounded-lg shadow-lg hover:bg-salBlue transition-all hover:text-text dark:hover:text-dark-text"
              >
                Sim
              </button>
              <button
                onClick={handleClosePopup}
                className="bg-gray-800 dark:bg-dark-card text-white-whiter dark:text-dark-text font-bold text-xl py-2 px-8 rounded-lg shadow-lg hover:bg-salBlue transition-all hover:text-text dark:hover:text-dark-text"
              >
                Não
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
